import { QueryParametersSchema, QueryParameterSchema, QueryParametersKey } from './types';

import { agencyFilterQueryFilter } from './agencyFilterQueryFilter';
import { campusIdFilterQueryFilter } from './campusIdFilterQueryFilter';
import { intakeTermFilterQueryFilter } from './intakeTermFilterQueryFilter';
import { nationalityFilterQueryFilter } from './nationalityFilterQueryFilter';
import { programIdFilterQueryFilter } from './programIdFilterQueryFilter';

const schema: QueryParametersSchema = {
  agencyId: agencyFilterQueryFilter,
  campusId: campusIdFilterQueryFilter,
  intakeTermId: intakeTermFilterQueryFilter,
  nationality: nationalityFilterQueryFilter,
  programId: programIdFilterQueryFilter,
};

const parameters = Object.entries(schema).map(([key, parameter]) => {
  return { key: key as keyof QueryParametersSchema, ...(parameter as QueryParameterSchema<QueryParametersKey>) };
});

export const get = <Key extends QueryParametersKey>(key: Key): QueryParametersSchema[Key] => schema[key];

export const queryParametersSchema = {
  get,
  parameters,
};
